import { createStore, createEffect, createEvent } from 'effector'

const changeModalRegistrationStatus = createEffect((payload: boolean) => payload)

const closeModalRegistrationClosed = createEvent()

const modalRegistrationClosed = createStore<{ open: boolean }>({
  open: false
})
  .on(closeModalRegistrationClosed, (state: any) => {
    return { ...state, open: false }
  })
  .on(changeModalRegistrationStatus.doneData, (state: any, payload: boolean) => {
    return { ...state, open: payload }
  })

export { changeModalRegistrationStatus, closeModalRegistrationClosed }

export default modalRegistrationClosed
